import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { APP_ROUTES } from '@/config/routes'

interface BreadcrumbItem {
  label: string
  to?: { name: string; params?: any } | string
  active?: boolean
}

/**
 * Composable to handle Premium Breadcrumbs (Specific to Default Layout)
 * Optimized to sync with standard Route hierarchy.
 */
export function useBreadcrumbs() {
  const route = useRoute()
  const { t } = useI18n()

  const breadcrumbs = computed(() => {
    // 1. Root always 'App'
    const items: BreadcrumbItem[] = [
      { label: t('common.app'), to: { name: APP_ROUTES.HOME?.name as string } }
    ]

    // 2. Iterate through matched routes to build levels
    route.matched.forEach((record, index) => {
      // Skip root home if we already have 'App'
      if (record.name === APP_ROUTES.HOME?.name) return

      const isLast = index === route.matched.length - 1
      const titleKey = record.meta?.titleKey as string

      if (titleKey) {
        items.push({
          label: t(titleKey),
          to: !isLast ? { name: record.name as string, params: route.params } : undefined,
          active: isLast
        })
      }
    })

    // Special case for Home: only show App
    if (route.name === APP_ROUTES.HOME?.name) {
      return [{ label: t('common.app'), active: true }]
    }

    return items
  })

  return {
    breadcrumbs
  }
}
